export enum SelectFormEnum {
  SCROLL = 'scroll',
  SEARCH = 'search',
}